import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
      <G clipPath="url(#c)">
        <Path
          fill="#fff"
          d="M14.498 5.596v1.821c0 1.172-.435 1.948-.877 2.43-.221.242-.445.41-.617.518a2.048 2.048 0 0 1-.277.144.229.229 0 0 1-.017.006c-.006.002-.004.001 0 .001h-.001l-.02-.007a2.329 2.329 0 0 1-.295-.146 3.24 3.24 0 0 1-.664-.517c-.476-.482-.945-1.258-.945-2.429v-1.82h3.713Z"
        />
        <Path
          stroke="#0B50A0"
          strokeWidth={0.08}
          d="M14.498 5.596v1.821c0 1.172-.435 1.948-.877 2.43-.221.242-.445.41-.617.518a2.048 2.048 0 0 1-.277.144.229.229 0 0 1-.017.006c-.006.002-.004.001 0 .001h-.001l-.02-.007a2.329 2.329 0 0 1-.295-.146 3.24 3.24 0 0 1-.664-.517c-.476-.482-.945-1.258-.945-2.429v-1.82h3.713Z"
        />
        <Path
          stroke="#F7FCFF"
          strokeWidth={0.08}
          d="M14.498 5.596v1.821c0 1.172-.435 1.948-.877 2.43-.221.242-.445.41-.617.518a2.048 2.048 0 0 1-.277.144.229.229 0 0 1-.017.006c-.006.002-.004.001 0 .001h-.001l-.02-.007a2.329 2.329 0 0 1-.295-.146 3.24 3.24 0 0 1-.664-.517c-.476-.482-.945-1.258-.945-2.429v-1.82h3.713Z"
        />
        <Mask
          id="d"
          width={5}
          height={6}
          x={10}
          y={5}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            d="M14.498 5.596v1.821c0 1.172-.435 1.948-.877 2.43-.221.242-.445.41-.617.518a2.048 2.048 0 0 1-.277.144.229.229 0 0 1-.017.006c-.006.002-.004.001 0 .001h-.001l-.02-.007a2.329 2.329 0 0 1-.295-.146 3.24 3.24 0 0 1-.664-.517c-.476-.482-.945-1.258-.945-2.429v-1.82h3.713Z"
          />
          <Path
            stroke="#fff"
            strokeWidth={0.08}
            d="M14.498 5.596v1.821c0 1.172-.435 1.948-.877 2.43-.221.242-.445.41-.617.518a2.048 2.048 0 0 1-.277.144.229.229 0 0 1-.017.006c-.006.002-.004.001 0 .001h-.001l-.02-.007a2.329 2.329 0 0 1-.295-.146 3.24 3.24 0 0 1-.664-.517c-.476-.482-.945-1.258-.945-2.429v-1.82h3.713Z"
          />
        </Mask>
        <G mask="url(#d)">
          <Path fill="#F50100" d="M10.501 5.306h4.32v1.7h-4.32z" />
          <Path
            fill="#F50100"
            d="M12.427 7.356c.138 0 .415-.157.484-.193.253-.156.438-.012.587.06.162.073.461.157.646 0 .184-.156.287-.144.414-.144.023-.18.023-.362.023-.567v-.144c-.161-.037-.242.012-.415.168-.172.157-.368.121-.622.025-.242-.109-.483-.302-.725 0-.07.084-.23.204-.392.204-.173 0-.323-.12-.392-.204-.253-.302-.483-.109-.725 0-.254.096-.461.132-.634-.025-.161-.156-.242-.205-.415-.168v.144c0 .205.012.386.035.567.127 0 .219-.012.403.145.184.156.495.072.645 0 .161-.073.346-.217.6-.06.068.035.333.192.483.192Z"
          />
          <Path
            fill="#FFD100"
            fillRule="evenodd"
            d="M11.261 6.08s.105.006.228.138c.123.133.577.048.577-.032s-.276-.127-.17-.264c.106-.137.285-.137.43-.066.04 0 .036.468.13.442.299-.081.78-.242.921-.173.186.09.328.068.281-.062-.047-.13-.168-.212-.402-.141-.234.071-.179.14-.38.14-.203 0-.55.115-.396-.14.138-.228.303-.233.366-.137.032.05-.23.158-.23.208 0 .07.675-.137.761-.137.087 0 .325-.005.349.066.023.071.167.137.057.203-.11.066-.29.108-.166.193.125.085.44.124.454.212.013.089.149.221.095.221-.055 0-.153.125-.245.087-.091-.038-.102-.072-.014-.102.088-.031.087-.16.014-.16-.072 0-.066-.01-.23-.055-.166-.046-.384-.096-.37 0 .013.095.124.3-.074.32-.198.02-.29.098-.329.035-.039-.063-.176-.148-.068-.175.108-.027.212.092.25.073.04-.02.124-.089.05-.171-.074-.082-.218-.085-.105-.147.113-.061.046-.108-.17.02-.216.127-.335.235-.525.22-.19-.015-.274.055-.335.034-.06-.02-.357.229-.443.165-.085-.063-.36-.087-.31-.165.049-.078.115-.118.19-.078.074.04.147.08.197.04.05-.04.209-.227.173-.254-.037-.027-.165-.074-.37-.074-.206 0-.211-.143-.26-.208-.049-.065.07-.075.07-.075Z"
            clipRule="evenodd"
          />
          <Path
            fill="#0B50A0"
            d="M12.427 8.556c.138 0 .415-.157.484-.193.253-.156.438-.012.587.06.162.073.461.157.646 0 .184-.156.287-.144.414-.144.023-.181.023-.362.023-.567v-.144c-.161-.037-.242.012-.415.168-.172.157-.368.12-.622.024-.242-.108-.483-.3-.725 0-.07.085-.23.205-.392.205-.173 0-.323-.12-.392-.205-.253-.3-.483-.108-.725 0-.254.097-.461.133-.634-.024-.161-.156-.242-.205-.415-.168v.144c0 .205.012.386.035.567.127 0 .219-.012.403.145.184.156.495.072.645 0 .161-.073.346-.217.6-.06.068.035.333.192.483.192ZM12.427 9.706c.138 0 .415-.157.484-.193.253-.157.438-.012.587.06.162.073.461.157.646 0 .184-.156.287-.144.414-.144.023-.181.023-.362.023-.567v-.145c-.161-.036-.242.013-.415.17-.172.156-.368.12-.622.023-.242-.108-.483-.301-.725 0-.07.085-.23.205-.392.205-.173 0-.323-.12-.392-.205-.253-.301-.483-.108-.725 0-.254.097-.461.133-.634-.024-.161-.156-.242-.205-.415-.169v.145c0 .205.012.386.035.567.127 0 .219-.012.403.144.184.157.495.073.645 0 .161-.072.346-.217.6-.06.068.036.333.193.483.193ZM12.427 10.856c.138 0 .415-.156.484-.193.253-.156.438-.012.587.06.162.073.461.157.646 0 .184-.156.287-.144.414-.144.023-.18.023-.362.023-.567v-.144c-.161-.037-.242.012-.415.168-.172.157-.368.12-.622.024-.242-.108-.483-.3-.725 0-.07.085-.23.205-.392.205-.173 0-.323-.12-.392-.205-.253-.3-.483-.108-.725 0-.254.097-.461.133-.634-.024-.161-.156-.242-.205-.415-.168v.144c0 .205.012.386.035.567.127 0 .219-.012.403.145.184.156.495.072.645 0 .161-.073.346-.217.6-.06.068.036.333.192.483.192Z"
          />
          <Path
            fill="#059334"
            stroke="#FFD100"
            strokeWidth={0.08}
            d="m12.788 8.93.01.025h.25l-.185.195-.017.018.008.022.088.264-.245-.13-.02-.01-.02.011-.216.128.063-.265.006-.023-.017-.017-.21-.193h.298l.01-.026.09-.246.107.248ZM11.828 7.93l.01.025h.25l-.185.195-.017.018.008.022.088.264-.245-.13-.02-.01-.02.011-.216.128.063-.265.006-.023-.017-.017-.21-.193h.298l.01-.026.09-.246.107.248ZM13.748 7.93l.01.025h.25l-.185.195-.017.018.008.022.088.264-.245-.13-.02-.01-.02.011-.216.128.063-.265.006-.023-.017-.017-.21-.193h.298l.01-.026.09-.246.107.248Z"
          />
        </G>
      </G>
      <Path
        fill="#FFD100"
        d="M10.423 10.373c.044.099.36.228.727.062.25-.117.412-.283.566-.578.045-.073.067-.166-.036-.22-.081-.05-.213-.105-.272-.154-.03-.025-.06-.043-.081-.062.015.012.03.025.044.043.147.148-.007.363-.17.492-.117.092-.33.32-.639.104-.066-.049-.22.154-.14.313ZM14.891 10.373c-.051.099-.367.228-.727.062-.25-.117-.412-.283-.573-.578-.037-.073-.06-.166.044-.22.08-.05.213-.105.271-.154.03-.025.052-.043.081-.062-.014.012-.03.025-.044.043-.147.148.008.363.162.492.117.092.338.32.647.104.066-.049.213.154.14.313Z"
      />
      <Path
        fill="#FFD100"
        d="M12.657 10.902c.588 0 1.492-.221 1.977-.995.08-.13 0-.197-.095-.24a1.137 1.137 0 0 1-.294-.178c.117.098.095.166.014.276-.375.522-.889.787-1.602.787-.713 0-1.227-.264-1.602-.787-.08-.11-.103-.178.007-.276a1.024 1.024 0 0 1-.294.178c-.095.043-.176.11-.095.24.485.774 1.396.995 1.984.995Z"
      />
      <Path
        fill="#F50100"
        d="M11.297 9.863c-.014-.061-.11-.036-.14.037a1.003 1.003 0 0 1-.102-.135c-.088-.11-.103-.184.022-.289.059-.049.176-.104.257-.043.17.117.081.308-.037.43ZM14.01 9.863c.014-.061.117-.036.146.037.037-.043.074-.086.103-.135.088-.11.103-.184-.03-.289-.05-.049-.168-.104-.256-.043-.162.117-.081.308.036.43Z"
      />
      <Path
        fill="#FFD100"
        d="M13.822 3.202c.008.029-.398.34-.523.687l.002.003c.39-.337.795-.472.795-.426-.003.05-.454.281-.723.721.003.026.004.051.005.077.168-.162.334-.226.334-.203 0 .03-.23.17-.35.438-.054.32-.238.557-.46.557-.218 0-.4-.225-.459-.535-.115-.283-.357-.43-.358-.46 0-.024.168.042.338.208 0-.024.002-.049.005-.073-.269-.445-.724-.68-.727-.73 0-.047.407.09.798.43-.123-.351-.533-.666-.524-.694.008-.025.356.192.635.51a.445.445 0 0 1 .159-.123l-.204-.283h.72l-.217.3a.47.47 0 0 1 .12.103c.28-.317.626-.531.634-.507Z"
      />
      <Path
        fill="#059334"
        d="M11.905 4.739c-.058-.083-.215-.12-.28-.046-.025.018-.059.018-.083.027-.041 0-.094.023-.078.115.045 0 .045.022.07.022.016-.009.059.158.141.15.091 0 .172.042.188.06.025.027.058.1.017.137a.198.198 0 0 0 0 .283c.107.091.38.228.685-.037.297-.255.759-.11.792-.018a.813.813 0 0 1 .066.192c.008.036.23.091.264.118.041.028.099.019.082-.063-.033-.256-.173-.292-.19-.411.083.009.14.009.174-.027.024-.037.057-.1.09-.12.025-.017.025-.036-.008-.027-.041.01-.066.028-.14.019-.176-.021-.132-.714-.713-.848-.36-.084-.807.487-.93.544a.068.068 0 0 1-.007.003.17.17 0 0 1-.14-.073Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
      <ClipPath id="c">
        <Path fill="#fff" d="M10.741 5.556h4v5.6h-4z" />
      </ClipPath>
    </Defs>
  </Icon>
);
